// extracted by mini-css-extract-plugin
export default {"validate-email__wrapper":"validate-email__wrapper--3Hzc0","validate-email__content":"validate-email__content--1JD_3","validate-email__panel":"validate-email__panel--2K5q3","validate-email__panel--has-hover":"validate-email__panel--has-hover--RZ4Hy","validate-email__button":"validate-email__button--RD21w","validate-email__panel__title":"validate-email__panel__title--3Y1Ra","validate-email__panel__description":"validate-email__panel__description--1r5-J"};
    if(module.hot) {
      // 1747648146638
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  